function getPreferred<T>(accessor: (key: string) => T | undefined, ...langs: string[]) {
  const first = langs.find((lang) => accessor(lang));
  return first ? accessor(first) : undefined;
}

/**
 * Gets the value for the first available of a set of keys.
 *
 * @param record The Record object.
 * @param keys Keys to try in order of priority.
 */
export const getPreferredFromRecord = <T>(record: Record<string, T>, ...keys: string[]) =>
  getPreferred((key) => record[key], ...keys);

/**
 * Gets the value for the first available of a set of keys.
 *
 * @param map The Map.
 * @param keys Keys to try in order of priority.
 */
export const getPreferredFromMap = <T>(map: Map<string, T>, ...keys: string[]) =>
  getPreferred((key) => map.get(key), ...keys);
